import { parseISO, formatRelative } from 'date-fns'
import pt from 'date-fns/locale/pt'

export const formatDateParse = (data) => {
  return formatRelative(parseISO(data), new Date(), {
    locale: pt,
    addSuffix: true
  })
}
